import { TemperatureDerationCatalog } from "./temperature-deration-catalog.model";
import { CatalogMetadata } from "./catalog-metadata.model";
import { CatalogScope } from "./catalog-scope.enum";

export class GradeCatalog {
  public constructor(init?: Partial<GradeCatalog>) {
    Object.assign(this, init);
    this.metadata = init && init.metadata ? new CatalogMetadata(init.metadata) : null;
  }

  id: string;
  name: string;
  minimumApiYieldStrength: number;
  poissonsRatio: number;
  thermalExpansionCoefficient: number;
  ultimateTensileStrength: number;
  youngsModulus: number;
  temperatureDeration: TemperatureDerationCatalog;
  strengthCalculationOption: string;
  density: number;
  specificHeatCapacity: number;
  thermalConductivity: number;
  discriminator: string;
  isLocked: boolean;
  metadata: CatalogMetadata;
  scope: CatalogScope;
}

export class GradeLookupResult {
  public constructor(init?: Partial<GradeLookupResult>) {
    Object.assign(this, init);
  }

  id: string;
  name: string;
}

export class GradesCatalogUi {
  public constructor(init?: Partial<GradesCatalogUi>) {
    this.selectedType = init && init.selectedType || 'TubularPipe';
  }
  selectedType: string;
}
